@if (meeting(); as meeting) {
  <section class="meeting-notice" role="status" aria-live="polite">
    <div class="meeting-notice-header">
      <span class="meeting-notice-eyebrow">
        {{ started() ? 'Reunión en curso' : 'Próxima reunión' }}
      </span>
      <button
        type="button"
        class="meeting-notice-dismiss"
        aria-label="Ocultar el aviso de esta reunión"
        (click)="dismiss()"
      >
        <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
      </button>
    </div>

    <p class="meeting-notice-title" [attr.title]="meeting.title">{{ meeting.title }}</p>
    <p class="meeting-notice-countdown">{{ countdown() }}</p>

    @if (meeting.meet_url) {
      <ion-button
        color="primary"
        size="small"
        [href]="meeting.meet_url"
        target="_blank"
        rel="noopener"
      >
        <ion-icon slot="start" name="videocam-outline" aria-hidden="true"></ion-icon>
        Unirse
      </ion-button>
    } @else if (meeting.calendar_url) {
      <ion-button
        color="dark"
        size="small"
        [href]="meeting.calendar_url"
        target="_blank"
        rel="noopener"
      >
        <ion-icon slot="start" name="calendar-outline" aria-hidden="true"></ion-icon>
        Ver en Calendar
      </ion-button>
    }
  </section>
}
